import { importActions, service } from '..';

const endpoint = 'cart';

export const importService = {
  importExcel: action => {
    let data = new FormData();
    data.append( 'file', action.data );  
    return service( endpoint ).post( data, ['import', 'excel'], { headers: { 'Content-Type': 'multipart/form-data' } } )
      .then( result => ( {result:result, data: result.data, type: importActions.LOAD } ) );
  },
  validate: action => service( endpoint ).post( action.data, ['import', 'validate'] ).then( result => result.data )
};